define ['./start.scss'], () ->
  ($scope, $rootScope, $state) ->
    $scope.go_to_next = () ->
      $state.go('root.payment.verify.disclaimer')



// WEBPACK FOOTER //
// ./components/payment/start/start.coffee